import { render } from "./MiscBoard.vue?vue&type=template&id=edb11448"
import script from "./MiscBoard.vue?vue&type=script&lang=js"
export * from "./MiscBoard.vue?vue&type=script&lang=js"

import "./MiscBoard.vue?vue&type=style&index=0&id=edb11448&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__